import { NotificationsBell as NotificationsBellComponent } from './NotificationsBell'

export default NotificationsBellComponent

export * from './NotificationsBell'
